import { render } from "./IconsLegendComponent.vue?vue&type=template&id=18026dc2&scoped=true"
import script from "./IconsLegendComponent.vue?vue&type=script&lang=js"
export * from "./IconsLegendComponent.vue?vue&type=script&lang=js"

import "./IconsLegendComponent.vue?vue&type=style&index=0&id=18026dc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18026dc2"]])

export default __exports__